export default "__VITE_ASSET__c9a2ea50__"